import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-switch',
  styleUrls: ['../../common-components/app-switch/app-switch.component.scss'],
  template: `
   <!-- <input type="input" [formControl]="formControl" [formlyAttributes]="field"> -->
   <!-- <div class="form-check">
    <label class="form-check-label" for="exampleCheck1">{{field.templateOptions.label}}</label>
    <input type="checkbox" class="form-check-input ml-0" [formControl]="formControl" [formlyAttributes]="field">
  </div> -->
  <!-- <div class="align-items-center h-100"> -->
    <!-- <input type="checkbox" class="form-check-input ml-0" [formControl]="formControl" [formlyAttributes]="field"> -->
  <label class="switch" [ngClass]="{ disabled : field.templateOptions.disabled }" style="transform: scale(.7);">
    <input type="checkbox" [formControl]="formControl" [formlyAttributes]="field" (change)="updateValue($event)">
    <!-- (change)="updateValue($event)" -->
    <!-- <input type="checkbox" class="d-none" [formControl]="formControl" [formlyAttributes]="field"> -->
    <span class="slider round"></span>
  </label>
<!-- </div> -->

 `,
})
export class FormlyFieldSwitch extends FieldType<FieldTypeConfig> {
  updateValue($event) {
    console.log($event.target.checked)
    this.formControl.setValue($event.target.checked);
  }
}
